import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAccessManagementSearchParams } from "@/hooks"
export const addUser = async (params: AccessManagementRequestType) => {
  const groups = [
    params.completeAccess && "admin",
    params.dashboardAccess !== "dashboard-without-access" &&
      params.dashboardAccess,
    params.scheduleAccess !== "schedule-without-access" &&
      params.scheduleAccess,
    params.salesAccess !== "sales-without-access" && params.salesAccess,
    params.ordersAccess !== "order-without-access" && params.ordersAccess,
    params.subscribeAccess !== "subscriptions-without-access" &&
      params.subscribeAccess,
  ].filter(Boolean) as string[]
  const { data } = await api.post<UserResponseType>(ENDPOINTS.USERS, {
    fullName: params.fullName,
    email: params.email,
    groups,
  })
  return data
}
const useAccessManagementAdd = () => {
  const queryClient = useQueryClient()
  const searchParams = useAccessManagementSearchParams()
  const addUserMutation = useMutation({
    mutationFn: addUser,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.USERS, searchParams],
      })
    },
  })
  return {
    addUserMutation,
  }
}
export default useAccessManagementAdd
